namespace TabAurous.Finance {
    export interface PDCClearanceDetailsForm {
        TransId: Serenity.IntegerEditor;
        VoucherNo: Serenity.StringEditor;
        InvoiceNo: Serenity.StringEditor;
        TransDate: Serenity.DateEditor;
        RefNo: Serenity.StringEditor;
        RefDate: Serenity.DateEditor;
        LedgerId: Serenity.IntegerEditor;
        Type: Serenity.StringEditor;
        AgainstId: Serenity.IntegerEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        Narration: Serenity.StringEditor;
        Status: Serenity.StringEditor;
        ChequeNo: Serenity.StringEditor;
        ChequeDate: Serenity.DateEditor;
        Amount: Serenity.DecimalEditor;
        CreatedBy: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        ExtraDate: Serenity.DateEditor;
        Extra1: Serenity.StringEditor;
        Extra2: Serenity.StringEditor;
        CompanyId: Serenity.IntegerEditor;
    }

    export class PDCClearanceDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Finance.PDCClearanceDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PDCClearanceDetailsForm.init)  {
                PDCClearanceDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(PDCClearanceDetailsForm, [
                    'TransId', w0,
                    'VoucherNo', w1,
                    'InvoiceNo', w1,
                    'TransDate', w2,
                    'RefNo', w1,
                    'RefDate', w2,
                    'LedgerId', w0,
                    'Type', w1,
                    'AgainstId', w0,
                    'VoucherTypeId', w0,
                    'Narration', w1,
                    'Status', w1,
                    'ChequeNo', w1,
                    'ChequeDate', w2,
                    'Amount', w3,
                    'CreatedBy', w0,
                    'FinancialYearId', w0,
                    'ExtraDate', w2,
                    'Extra1', w1,
                    'Extra2', w1,
                    'CompanyId', w0
                ]);
            }
        }
    }
}
